import './plugins/datadog'

import { datadogRum } from '@datadog/browser-rum'
import { createPinia } from 'pinia'
import PortalVue from 'portal-vue'
import { configureCompat } from 'vue'

import { client } from '@maxsystems/client'

import App from './App.vue'
import { name, version } from '../package.json'
import AuthPlugin from './plugins/auth'
import features from './plugins/features'
import * as icons from './plugins/icons'
import { router } from './plugins/router'
import * as versioning from './shared/version'
import filters from './ui/vue/filters'
import { getMobileAuthToken } from '~/shared/mobile-auth-token.js'
import UI, { vuetify } from '~/ui/vue'
import vue3CompatConfig from '~/vue3.compat.config'

import '~/ui/styles/app.scss'

export const minifyTheme = css => css
  .replace(/\n\s?|\s(?=[\w!#\-{])/g, '')
  .replace(/\s{2,}/g, ' ')

configureCompat(vue3CompatConfig)

// set current release version in order to be able to determine if app was updated
// whenever we get a ChunkLoadError
versioning.init()

client.config({ name, version })

/**
 * Handles the `created` lifecycle logic for the main Vue app instance.
 * @param {Object} context - The Vue app instance (`this` context).
 * @returns {Promise<void|undefined>} Resolves when setup is complete or skipped.
 */
export const handleAppCreated = async context => {
  /**
   * Embed mobile routes use a cookie-based auth token to bypass
   * the authentication and authorization process via SSO/CAS ($auth).
   */
  await context.$router.isReady()
  if (context.$route.meta.mobile && getMobileAuthToken()) return

  context.$auth.setup()
}

export const app = createApp({
  provide: () => ({ features }),
  router,
  async created () {
    await handleAppCreated(this)
  },
  render: h => h(App)
})

app.use(createPinia())
app.use(vuetify)
app.use(PortalVue)
app.use(AuthPlugin)
app.use(UI, { icons })
app.use(router)
app.use(filters)

app.config.errorHandler = error => {
  if (process.env.NODE_ENV === 'production') {
    datadogRum.addError(error)
    return
  }
  console.error(error)
}

export default app.mount('#app')
